import { render, staticRenderFns } from "./RemoteSims.vue?vue&type=template&id=2f68b910&scoped=true&"
import script from "./RemoteSims.vue?vue&type=script&lang=js&"
export * from "./RemoteSims.vue?vue&type=script&lang=js&"
import style0 from "./RemoteSims.vue?vue&type=style&index=0&id=2f68b910&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68b910",
  null
  
)

export default component.exports